export const UPDATE_HOB_LANDING_PARAMS        : string = "UPDATE_HOB_LANDING_PARAMS"
export const UPDATE_HOB_LANDING_RESPONSE      : string = "UPDATE_HOB_LANDING_RESPONSE"
export const UPDATE_HOB_DESTINATION_LOCATION	: string = "UPDATE_HOB_DESTINATION_LOCATION"
export const UPDATE_HOB_SOURCE_LOCATION       : string = "UPDATE_HOB_SOURCE_LOCATION"
export const UPDATE_HOB_LISTING_PARAMS        : string = "UPDATE_HOB_LISTING_PARAMS"
export const UPDATE_HOB_LISTING_RESPONSE      : string = "UPDATE_HOB_LISTING_RESPONSE"
export const UPDATE_HOB_THANKYOU_PARAMS       : string = "UPDATE_HOB_THANKYOU_PARAMS"
export const UPDATE_HOB_THANKYOU_RESPONSE     : string = "UPDATE_HOB_THANKYOU_RESPONSE"
export const UPDATE_HOB_PICKUP_TIME           : string = "UPDATE_HOB_PICKUP_TIME"
export const CLEAR_HOB_LISTING_DATA           : string = "CLEAR_HOB_LISTING_DATA"   
export const UPDATE_HOB_USER_DATA             : string = "UPDATE_HOB_USER_DATA"
export const UPDATE_USE_SOURCE_LOCATION     	: string = "UPDATE_USE_SOURCE_LOCATION"      